import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { HomePage } from './home.page';

import { TypeKrNamePipeModule } from '../../../pipe/tkrnamepipe.module';
import { TimeAgoPipeModule } from '../../../pipe/time-ago-pipe.module';
import { OrderByPipeModule } from '../../../pipe/orderbypipe.module';
import { OrderByPFPipeModule } from '../../../pipe/orderbypf.module';
import { DayPipeModule } from '../../../pipe/daypipe.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { MatchPipeModule } from '../../../pipe/matchpipe.module';
import { ChcatPipeModule } from '../../../pipe/chcatpipe.module';
import { BlockchkPipeModule } from '../../../pipe/blockchkpipe.module';
import { VisitchkPipeModule } from '../../../pipe/visitchkpipe.module';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { DropListScrollerDirective } from "./drop-list-scroller.directive";

//import { AdMob } from "@ionic-native/admob-plus/ngx";
//import { Geolocation } from '@ionic-native/geolocation';
const routes: Routes = [
  {
    path: '',
    component: HomePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),TypeKrNamePipeModule,TimeAgoPipeModule,MatchPipeModule,
    OrderByPipeModule,OrderByPFPipeModule,TranslateModule,DayPipeModule,ChcatPipeModule,BlockchkPipeModule,VisitchkPipeModule,
    DragDropModule
  ],
  declarations: [HomePage, DropListScrollerDirective],
  entryComponents:[],
  providers:[TranslatePipe]
})
export class HomePageModule {}
